var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMirDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0f754e",
  fillRule: "evenodd",
  d: "M6.22 8.73c.21 0 .85-.06 1.12.85l.87 3.02h.16l.88-3.02c.27-.92.95-.85 1.23-.85h2.1v6.54h-2.14v-3.85h-.15l-1.2 3.85H7.5l-1.2-3.86h-.15v3.86H4V8.73zm9.44 0v3.86h.17L17.3 9.4c.28-.63.88-.68.88-.68h2.08v6.54h-2.2V11.4h-.16l-1.43 3.18c-.28.63-.91.68-.91.68h-2.08V8.73h2.2Zm12.15 3.1c-.3.87-1.26 1.5-2.32 1.5h-2.3v1.94h-2.08v-3.43h6.7Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#mir-dark_svg__a)",
  fillRule: "evenodd",
  d: "M25.59 8.73H21c.1 1.46 1.36 2.7 2.66 2.7h4.3c.25-1.2-.6-2.7-2.37-2.7",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "mir-dark_svg__a",
  x1: 28,
  x2: 21,
  y1: 10.43,
  y2: 10.43,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1f5cd7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#02aeff"
})))));
export default SvgMirDark;